import { useCurrentLocale } from '../contexts/CurrentLanguageContext'

function formatDate(date: Date, formatter: Intl.DateTimeFormat) {
	return formatter.format(date)
}

export function useFormatDate() {
	const locale = useCurrentLocale()
	const formatter = new Intl.DateTimeFormat([locale])

	return (date: Date) => formatDate(date, formatter)
}
